import {Center} from '@hmlet/ui'

import {Outlet, createFileRoute, redirect, useNavigate} from '@tanstack/react-router'
import {useEffect} from 'react'

import {useUser} from '@contexts/UserContext'

export const Route = createFileRoute('/_public')({
  beforeLoad: ({context}) => {
    if (context.auth.isAuthenticated) throw redirect({to: '/'})
  },
  component: PublicLayout,
})

function PublicLayout() {
  const navigate = useNavigate()
  const {isAuthenticated} = useUser()

  // Reactive: after login the router context updates, then we leave the public pages.
  useEffect(() => {
    if (isAuthenticated) navigate({to: '/', replace: true})
  }, [isAuthenticated, navigate])

  return (
    <Center as="main" className="min-h-screen bg-background">
      <Outlet />
    </Center>
  )
}
